<ul class="navbar-nav me-auto mb-2 mb-lg-0">
  <!-- Home -->
  <li class="nav-item">
    <a class="nav-link active" aria-current="page" routerLink="/" routerLinkActive="active" 
       [routerLinkActiveOptions]="{exact: true}" (click)="collapseNavbar()">
       <i class="fa fa-dashboard me-1"></i>Dashboard
    </a>
  </li>
  
  <!-- Certificate Operations -->
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownCertificateOps" role="button" 
       data-bs-toggle="dropdown" aria-expanded="false">
       <i class="fa fa-id-card me-1"></i>Certificate Operations
    </a>
    <ul class="dropdown-menu shadow" aria-labelledby="navbarDropdownCertificateOps">
      <li>
        <a class="dropdown-item" routerLink="/issueCertificate" routerLinkActive="active" (click)="collapseNavbar()">
          <i class="fa fa-plus-circle me-2"></i>Issue Certificate
        </a>
      </li>
      <li *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('ExcelUpload')">
        <a class="dropdown-item" routerLink="/issueCertificate/bulkIndividual" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-upload me-2"></i>Bulk Upload
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/reports/printCertificate" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-print me-2"></i>Print Certificate
        </a>
      </li>
      <li *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('CanRenewAllPolicies')">
        <a class="dropdown-item" routerLink="/reports/renewCertificate" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-refresh me-2"></i>Renew Certificate
        </a>
      </li>
    </ul>
  </li>
  
  <!-- Payment Operations -->
  <li class="nav-item" *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('538539AddPayment')">
    <a class="nav-link" routerLink="/empAddPayment" routerLinkActive="active" (click)="collapseNavbar()">
      <i class="fa fa-credit-card me-1"></i>Payment Operations
    </a>
  </li>
  
  <!-- Reports Section -->
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownReports" role="button" 
       data-bs-toggle="dropdown" aria-expanded="false">
       <i class="fa fa-chart-bar me-1"></i>Reports
    </a>
    <ul class="dropdown-menu shadow reports-menu" aria-labelledby="navbarDropdownReports">
      <li>
        <a class="dropdown-item" routerLink="/reports/certificateReport" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-file me-2"></i>Certificate Report
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/reports/dealerReport" *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('CanViewDealerBalanceReport')"
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-users me-2"></i>Dealer Report
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/reports/dealerAggregateReport" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-bar-chart me-2"></i>Dealer Aggregate Report
        </a>
      </li>
      
      <li>
        <a class="dropdown-item" routerLink="/reports/dealerBalanceReport" *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('CanViewDealerBalanceReport')" routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-balance-scale me-2"></i>Dealer Balance Details
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/reports/dealerInactivityReport" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-clock-o me-2"></i>Dealer Inactivity Report
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/reports/monthlyActivity" 
           routerLinkActive="active" (click)="collapseNavbar()">
           <i class="fa fa-calendar-check-o me-2"></i>Monthly Activity Report
        </a>
      </li>

    </ul>
  </li>
</ul>
